import { default as aboutjWYSzj7p86Meta } from "/var/www/frontend-prod/pages/about.vue?macro=true";
import { default as _91id_93ZBE8yvYRRIMeta } from "/var/www/frontend-prod/pages/article/[id].vue?macro=true";
import { default as articlesdbxAPiNr4xMeta } from "/var/www/frontend-prod/pages/articles.vue?macro=true";
import { default as calendly_meeting_confirmtGxzM3Wcx0Meta } from "/var/www/frontend-prod/pages/calendly_meeting_confirm.vue?macro=true";
import { default as contact_form_confirm8hQAnQdcETMeta } from "/var/www/frontend-prod/pages/contact_form_confirm.vue?macro=true";
import { default as contactAzCD5LDtmdMeta } from "/var/www/frontend-prod/pages/contact.vue?macro=true";
import { default as event_registration_confirmpFYnRarCRXMeta } from "/var/www/frontend-prod/pages/event_registration_confirm.vue?macro=true";
import { default as _91id_930EYdqPB5yyMeta } from "/var/www/frontend-prod/pages/event/[id].vue?macro=true";
import { default as archive5UCfTzPBKMMeta } from "/var/www/frontend-prod/pages/event/archive.vue?macro=true";
import { default as events_oldzmZ4vzBkPBMeta } from "/var/www/frontend-prod/pages/events_old.vue?macro=true";
import { default as eventsiN7y8DbCjwMeta } from "/var/www/frontend-prod/pages/events.vue?macro=true";
import { default as indexYiE2jREesCMeta } from "/var/www/frontend-prod/pages/index.vue?macro=true";
import { default as membershipyM0cJaqTXlMeta } from "/var/www/frontend-prod/pages/membership.vue?macro=true";
import { default as newsletter_subscriptiontg3P9wpudNMeta } from "/var/www/frontend-prod/pages/newsletter_subscription.vue?macro=true";
import { default as opero_45club_45confirmRLIvKEJyI2Meta } from "/var/www/frontend-prod/pages/opero-club-confirm.vue?macro=true";
import { default as projects5ARjKZNeNDMeta } from "/var/www/frontend-prod/pages/projects.vue?macro=true";
import { default as _91id_93Y1XDYADlSuMeta } from "/var/www/frontend-prod/pages/space/[id].vue?macro=true";
import { default as spacesdp2hjBDF3PMeta } from "/var/www/frontend-prod/pages/spaces.vue?macro=true";
export default [
  {
    name: aboutjWYSzj7p86Meta?.name ?? "about___en",
    path: aboutjWYSzj7p86Meta?.path ?? "/en/about",
    meta: aboutjWYSzj7p86Meta || {},
    alias: aboutjWYSzj7p86Meta?.alias || [],
    redirect: aboutjWYSzj7p86Meta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/about.vue").then(m => m.default || m)
  },
  {
    name: aboutjWYSzj7p86Meta?.name ?? "about___cs",
    path: aboutjWYSzj7p86Meta?.path ?? "/cs/o-nas",
    meta: aboutjWYSzj7p86Meta || {},
    alias: aboutjWYSzj7p86Meta?.alias || [],
    redirect: aboutjWYSzj7p86Meta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/about.vue").then(m => m.default || m)
  },
  {
    name: _91id_93ZBE8yvYRRIMeta?.name ?? "article-id___en",
    path: _91id_93ZBE8yvYRRIMeta?.path ?? "/en/blog/:id",
    meta: _91id_93ZBE8yvYRRIMeta || {},
    alias: _91id_93ZBE8yvYRRIMeta?.alias || [],
    redirect: _91id_93ZBE8yvYRRIMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/article/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93ZBE8yvYRRIMeta?.name ?? "article-id___cs",
    path: _91id_93ZBE8yvYRRIMeta?.path ?? "/cs/blog/:id",
    meta: _91id_93ZBE8yvYRRIMeta || {},
    alias: _91id_93ZBE8yvYRRIMeta?.alias || [],
    redirect: _91id_93ZBE8yvYRRIMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/article/[id].vue").then(m => m.default || m)
  },
  {
    name: articlesdbxAPiNr4xMeta?.name ?? "articles___en",
    path: articlesdbxAPiNr4xMeta?.path ?? "/en/blog",
    meta: articlesdbxAPiNr4xMeta || {},
    alias: articlesdbxAPiNr4xMeta?.alias || [],
    redirect: articlesdbxAPiNr4xMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/articles.vue").then(m => m.default || m)
  },
  {
    name: articlesdbxAPiNr4xMeta?.name ?? "articles___cs",
    path: articlesdbxAPiNr4xMeta?.path ?? "/cs/blog",
    meta: articlesdbxAPiNr4xMeta || {},
    alias: articlesdbxAPiNr4xMeta?.alias || [],
    redirect: articlesdbxAPiNr4xMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/articles.vue").then(m => m.default || m)
  },
  {
    name: calendly_meeting_confirmtGxzM3Wcx0Meta?.name ?? "calendly_meeting_confirm___en",
    path: calendly_meeting_confirmtGxzM3Wcx0Meta?.path ?? "/en/calendly-meeting-confirm",
    meta: calendly_meeting_confirmtGxzM3Wcx0Meta || {},
    alias: calendly_meeting_confirmtGxzM3Wcx0Meta?.alias || [],
    redirect: calendly_meeting_confirmtGxzM3Wcx0Meta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/calendly_meeting_confirm.vue").then(m => m.default || m)
  },
  {
    name: calendly_meeting_confirmtGxzM3Wcx0Meta?.name ?? "calendly_meeting_confirm___cs",
    path: calendly_meeting_confirmtGxzM3Wcx0Meta?.path ?? "/cs/calendly-meeting-confirm",
    meta: calendly_meeting_confirmtGxzM3Wcx0Meta || {},
    alias: calendly_meeting_confirmtGxzM3Wcx0Meta?.alias || [],
    redirect: calendly_meeting_confirmtGxzM3Wcx0Meta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/calendly_meeting_confirm.vue").then(m => m.default || m)
  },
  {
    name: contact_form_confirm8hQAnQdcETMeta?.name ?? "contact_form_confirm___en",
    path: contact_form_confirm8hQAnQdcETMeta?.path ?? "/en/contact-form-confirm",
    meta: contact_form_confirm8hQAnQdcETMeta || {},
    alias: contact_form_confirm8hQAnQdcETMeta?.alias || [],
    redirect: contact_form_confirm8hQAnQdcETMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/contact_form_confirm.vue").then(m => m.default || m)
  },
  {
    name: contact_form_confirm8hQAnQdcETMeta?.name ?? "contact_form_confirm___cs",
    path: contact_form_confirm8hQAnQdcETMeta?.path ?? "/cs/contact-form-confirm",
    meta: contact_form_confirm8hQAnQdcETMeta || {},
    alias: contact_form_confirm8hQAnQdcETMeta?.alias || [],
    redirect: contact_form_confirm8hQAnQdcETMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/contact_form_confirm.vue").then(m => m.default || m)
  },
  {
    name: contactAzCD5LDtmdMeta?.name ?? "contact___en",
    path: contactAzCD5LDtmdMeta?.path ?? "/en/contact",
    meta: contactAzCD5LDtmdMeta || {},
    alias: contactAzCD5LDtmdMeta?.alias || [],
    redirect: contactAzCD5LDtmdMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactAzCD5LDtmdMeta?.name ?? "contact___cs",
    path: contactAzCD5LDtmdMeta?.path ?? "/cs/kontakt",
    meta: contactAzCD5LDtmdMeta || {},
    alias: contactAzCD5LDtmdMeta?.alias || [],
    redirect: contactAzCD5LDtmdMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: event_registration_confirmpFYnRarCRXMeta?.name ?? "event_registration_confirm___en",
    path: event_registration_confirmpFYnRarCRXMeta?.path ?? "/en/registration-confirm",
    meta: event_registration_confirmpFYnRarCRXMeta || {},
    alias: event_registration_confirmpFYnRarCRXMeta?.alias || [],
    redirect: event_registration_confirmpFYnRarCRXMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/event_registration_confirm.vue").then(m => m.default || m)
  },
  {
    name: event_registration_confirmpFYnRarCRXMeta?.name ?? "event_registration_confirm___cs",
    path: event_registration_confirmpFYnRarCRXMeta?.path ?? "/cs/registration-confirm",
    meta: event_registration_confirmpFYnRarCRXMeta || {},
    alias: event_registration_confirmpFYnRarCRXMeta?.alias || [],
    redirect: event_registration_confirmpFYnRarCRXMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/event_registration_confirm.vue").then(m => m.default || m)
  },
  {
    name: _91id_930EYdqPB5yyMeta?.name ?? "event-id___en",
    path: _91id_930EYdqPB5yyMeta?.path ?? "/en/events/:id",
    meta: _91id_930EYdqPB5yyMeta || {},
    alias: _91id_930EYdqPB5yyMeta?.alias || [],
    redirect: _91id_930EYdqPB5yyMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/event/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_930EYdqPB5yyMeta?.name ?? "event-id___cs",
    path: _91id_930EYdqPB5yyMeta?.path ?? "/cs/akce/:id",
    meta: _91id_930EYdqPB5yyMeta || {},
    alias: _91id_930EYdqPB5yyMeta?.alias || [],
    redirect: _91id_930EYdqPB5yyMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/event/[id].vue").then(m => m.default || m)
  },
  {
    name: archive5UCfTzPBKMMeta?.name ?? "event-archive___en",
    path: archive5UCfTzPBKMMeta?.path ?? "/en/events/archive",
    meta: archive5UCfTzPBKMMeta || {},
    alias: archive5UCfTzPBKMMeta?.alias || [],
    redirect: archive5UCfTzPBKMMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/event/archive.vue").then(m => m.default || m)
  },
  {
    name: archive5UCfTzPBKMMeta?.name ?? "event-archive___cs",
    path: archive5UCfTzPBKMMeta?.path ?? "/cs/akce/archiv",
    meta: archive5UCfTzPBKMMeta || {},
    alias: archive5UCfTzPBKMMeta?.alias || [],
    redirect: archive5UCfTzPBKMMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/event/archive.vue").then(m => m.default || m)
  },
  {
    name: events_oldzmZ4vzBkPBMeta?.name ?? "events_old___en",
    path: events_oldzmZ4vzBkPBMeta?.path ?? "/en/events_old",
    meta: events_oldzmZ4vzBkPBMeta || {},
    alias: events_oldzmZ4vzBkPBMeta?.alias || [],
    redirect: events_oldzmZ4vzBkPBMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/events_old.vue").then(m => m.default || m)
  },
  {
    name: events_oldzmZ4vzBkPBMeta?.name ?? "events_old___cs",
    path: events_oldzmZ4vzBkPBMeta?.path ?? "/cs/events_old",
    meta: events_oldzmZ4vzBkPBMeta || {},
    alias: events_oldzmZ4vzBkPBMeta?.alias || [],
    redirect: events_oldzmZ4vzBkPBMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/events_old.vue").then(m => m.default || m)
  },
  {
    name: eventsiN7y8DbCjwMeta?.name ?? "events___en",
    path: eventsiN7y8DbCjwMeta?.path ?? "/en/events",
    meta: eventsiN7y8DbCjwMeta || {},
    alias: eventsiN7y8DbCjwMeta?.alias || [],
    redirect: eventsiN7y8DbCjwMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/events.vue").then(m => m.default || m)
  },
  {
    name: eventsiN7y8DbCjwMeta?.name ?? "events___cs",
    path: eventsiN7y8DbCjwMeta?.path ?? "/cs/akce",
    meta: eventsiN7y8DbCjwMeta || {},
    alias: eventsiN7y8DbCjwMeta?.alias || [],
    redirect: eventsiN7y8DbCjwMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/events.vue").then(m => m.default || m)
  },
  {
    name: indexYiE2jREesCMeta?.name ?? "index___en",
    path: indexYiE2jREesCMeta?.path ?? "/en",
    meta: indexYiE2jREesCMeta || {},
    alias: indexYiE2jREesCMeta?.alias || [],
    redirect: indexYiE2jREesCMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexYiE2jREesCMeta?.name ?? "index___cs",
    path: indexYiE2jREesCMeta?.path ?? "/cs",
    meta: indexYiE2jREesCMeta || {},
    alias: indexYiE2jREesCMeta?.alias || [],
    redirect: indexYiE2jREesCMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/index.vue").then(m => m.default || m)
  },
  {
    name: membershipyM0cJaqTXlMeta?.name ?? "membership___en",
    path: membershipyM0cJaqTXlMeta?.path ?? "/en/membership",
    meta: membershipyM0cJaqTXlMeta || {},
    alias: membershipyM0cJaqTXlMeta?.alias || [],
    redirect: membershipyM0cJaqTXlMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/membership.vue").then(m => m.default || m)
  },
  {
    name: membershipyM0cJaqTXlMeta?.name ?? "membership___cs",
    path: membershipyM0cJaqTXlMeta?.path ?? "/cs/clenstvi",
    meta: membershipyM0cJaqTXlMeta || {},
    alias: membershipyM0cJaqTXlMeta?.alias || [],
    redirect: membershipyM0cJaqTXlMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/membership.vue").then(m => m.default || m)
  },
  {
    name: newsletter_subscriptiontg3P9wpudNMeta?.name ?? "newsletter_subscription___en",
    path: newsletter_subscriptiontg3P9wpudNMeta?.path ?? "/en/newsletter-subscription",
    meta: newsletter_subscriptiontg3P9wpudNMeta || {},
    alias: newsletter_subscriptiontg3P9wpudNMeta?.alias || [],
    redirect: newsletter_subscriptiontg3P9wpudNMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/newsletter_subscription.vue").then(m => m.default || m)
  },
  {
    name: newsletter_subscriptiontg3P9wpudNMeta?.name ?? "newsletter_subscription___cs",
    path: newsletter_subscriptiontg3P9wpudNMeta?.path ?? "/cs/newsletter-subscription",
    meta: newsletter_subscriptiontg3P9wpudNMeta || {},
    alias: newsletter_subscriptiontg3P9wpudNMeta?.alias || [],
    redirect: newsletter_subscriptiontg3P9wpudNMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/newsletter_subscription.vue").then(m => m.default || m)
  },
  {
    name: opero_45club_45confirmRLIvKEJyI2Meta?.name ?? "opero-club-confirm___en",
    path: opero_45club_45confirmRLIvKEJyI2Meta?.path ?? "/en/opero-club-confirm",
    meta: opero_45club_45confirmRLIvKEJyI2Meta || {},
    alias: opero_45club_45confirmRLIvKEJyI2Meta?.alias || [],
    redirect: opero_45club_45confirmRLIvKEJyI2Meta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/opero-club-confirm.vue").then(m => m.default || m)
  },
  {
    name: opero_45club_45confirmRLIvKEJyI2Meta?.name ?? "opero-club-confirm___cs",
    path: opero_45club_45confirmRLIvKEJyI2Meta?.path ?? "/cs/opero-club-confirm",
    meta: opero_45club_45confirmRLIvKEJyI2Meta || {},
    alias: opero_45club_45confirmRLIvKEJyI2Meta?.alias || [],
    redirect: opero_45club_45confirmRLIvKEJyI2Meta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/opero-club-confirm.vue").then(m => m.default || m)
  },
  {
    name: projects5ARjKZNeNDMeta?.name ?? "projects___en",
    path: projects5ARjKZNeNDMeta?.path ?? "/en/projects",
    meta: projects5ARjKZNeNDMeta || {},
    alias: projects5ARjKZNeNDMeta?.alias || [],
    redirect: projects5ARjKZNeNDMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/projects.vue").then(m => m.default || m)
  },
  {
    name: projects5ARjKZNeNDMeta?.name ?? "projects___cs",
    path: projects5ARjKZNeNDMeta?.path ?? "/cs/projekty",
    meta: projects5ARjKZNeNDMeta || {},
    alias: projects5ARjKZNeNDMeta?.alias || [],
    redirect: projects5ARjKZNeNDMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/projects.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Y1XDYADlSuMeta?.name ?? "space-id___en",
    path: _91id_93Y1XDYADlSuMeta?.path ?? "/en/space/:id",
    meta: _91id_93Y1XDYADlSuMeta || {},
    alias: _91id_93Y1XDYADlSuMeta?.alias || [],
    redirect: _91id_93Y1XDYADlSuMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/space/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93Y1XDYADlSuMeta?.name ?? "space-id___cs",
    path: _91id_93Y1XDYADlSuMeta?.path ?? "/cs/prostor/:id",
    meta: _91id_93Y1XDYADlSuMeta || {},
    alias: _91id_93Y1XDYADlSuMeta?.alias || [],
    redirect: _91id_93Y1XDYADlSuMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/space/[id].vue").then(m => m.default || m)
  },
  {
    name: spacesdp2hjBDF3PMeta?.name ?? "spaces___en",
    path: spacesdp2hjBDF3PMeta?.path ?? "/en/space",
    meta: spacesdp2hjBDF3PMeta || {},
    alias: spacesdp2hjBDF3PMeta?.alias || [],
    redirect: spacesdp2hjBDF3PMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/spaces.vue").then(m => m.default || m)
  },
  {
    name: spacesdp2hjBDF3PMeta?.name ?? "spaces___cs",
    path: spacesdp2hjBDF3PMeta?.path ?? "/cs/prostor",
    meta: spacesdp2hjBDF3PMeta || {},
    alias: spacesdp2hjBDF3PMeta?.alias || [],
    redirect: spacesdp2hjBDF3PMeta?.redirect || undefined,
    component: () => import("/var/www/frontend-prod/pages/spaces.vue").then(m => m.default || m)
  }
]